import { useEffect } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";

import Homeserimg1 from "@/assets/Homeserimg1.png";
import Homeserimg2 from "@/assets/Homeserimg2.png";
import Homeserimg3 from "@/assets/Homeserimg3.png";
import Homeserimg4 from "@/assets/Homeserimg4.png";
import Homeserimg5 from "@/assets/Homeserimg5.png";
import Servicebg from "@/assets/pexels-rdne-7821911 1.jpg";
import whatsappicon from "@/assets/icons8-whatsapp-50.png";
import getstartedimg from "@/assets/undraw_investing_kncz 1.png";

export default function ServicePage() {
  const services = [
    {
      id: "professionals",
      name: "Professionals", 
      img: Homeserimg1,
      infoTitle: "How Do We Help Working Professionals?",
      infoList: [
        "Help you manage your money while you focus on your career.",
        "Create structured financial plans tailored to your goals.",
        "Guide you on smart investments and effective tax planning.",
        "Ensure your future is secure with worry-free financial decisions.",
      ],
      footerTitle:
        "Let us handle your finances so you can achieve success without compromise.",
    },
    {
      id: "families",
      name: "Families",
      img: Homeserimg2,
      infoTitle: "How Do We Help Families?",
      infoList: [
        "Help you organize your income and expenses.",
        "Building Savings: Create a safety net for unexpected expenses.",
        "Smart Investments: Grow your money for milestones like a home or vacations.",
        "Insurance Advice: Ensure your family is financially protected.",
      ],
      footerTitle:
        "Let us guide you step by step, so you can give your family the best life possible.",
    },
    {
      id: "young-parents",
      name: "Young Parents",
      img: Homeserimg3,
      infoTitle: "How Do We Help Young Parents?",
      infoList: [
        "Plan early for your child's education and future needs.",
        "Build a strong savings foundation to handle unexpected expenses.",
        "Make smart investments for life goals like buying a home or family vacations.",
        "Get expert insurance advice to protect your family financially.",
      ],
      footerTitle:
        "Let us guide you step by step, so you can give your family the best life possible.",
    },
    {
      id: "women",
      name: "Women",
      img: Homeserimg4,
      infoTitle: "How Do We Help Women in Financial Planning?",
      infoList: [
        "Organize your finances by managing income, savings, and expenses effectively.",
        "Grow your wealth through smart investments to achieve personal goals.",
        "Secure your future with retirement planning, insurance, and risk management.",
        "Gain confidence with expert guidance to take full control of your finances.",
      ],
      footerTitle:
        "Let us help you create a financial plan that works for you and your unique needs.",
    },
    {
      id: "nri-services",
      name: "NRI Services",
      img: Homeserimg5,
      infoTitle: "How Do We Help NRIs?",
      infoList: [
        "We help NRIs invest confidently in India with tailored strategies.",
        "Get expert investment advice aligned with your financial goals.",
        "Assistance with taxation to ensure compliance and peace of mind.",
        "Full support from planning to execution for a smooth experience.",
      ],
      footerTitle:
        "Whether it's growing your wealth or planning for the future, we make investing in India simple and rewarding.",
    },
  ];

  // SEO Meta Tags Setup
  useEffect(() => {
    // Set page title
    document.title = "Financial Planning Services Mumbai - Investment Advisory, Retirement Planning & Wealth Management";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Comprehensive financial planning services in Mumbai: SIP investment, mutual fund consulting, tax planning, retirement planning, portfolio management for professionals, families, women & NRIs. Expert wealth management solutions.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Comprehensive financial planning services in Mumbai: SIP investment, mutual fund consulting, tax planning, retirement planning, portfolio management for professionals, families, women & NRIs. Expert wealth management solutions.";
      document.head.appendChild(meta);
    }

    // Meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", "financial planning services Mumbai, SIP investment advisor, mutual fund consultant Mumbai, retirement planning services, tax planning consultant, portfolio management services, wealth management for professionals, family financial planning, NRI investment services Mumbai, women financial advisor");
    } else {
      const meta = document.createElement('meta');
      meta.name = "keywords";
      meta.content = "financial planning services Mumbai, SIP investment advisor, mutual fund consultant Mumbai, retirement planning services, tax planning consultant, portfolio management services, wealth management for professionals, family financial planning, NRI investment services Mumbai, women financial advisor";
      document.head.appendChild(meta);
    }

    // Open Graph Meta Tags
    const ogTags = [
      { property: "og:title", content: "Financial Planning Services Mumbai - Oaktree Financial Services" },
      { property: "og:description", content: "Expert financial planning, investment advisory, retirement planning & wealth management services for professionals, families, women & NRIs in Mumbai." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.oaktree.in/services" },
    ];

    ogTags.forEach(tag => {
      let ogMeta = document.querySelector(`meta[property="${tag.property}"]`);
      if (ogMeta) {
        ogMeta.setAttribute("content", tag.content);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute("property", tag.property);
        meta.content = tag.content;
        document.head.appendChild(meta);
      }
    });

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", "https://www.oaktree.in/services");
    } else {
      const link = document.createElement('link');
      link.rel = "canonical";
      link.href = "https://www.oaktree.in/services";
      document.head.appendChild(link);
    }

    // Structured Data for Services
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Financial Planning Services",
      "provider": {
        "@type": "FinancialService",
        "name": "Oaktree Financial Services",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "160 Powai Plaza Hiranandani Business Park Powai",
          "addressLocality": "Mumbai",
          "postalCode": "400076",
          "addressCountry": "IN"
        }
      },
      "areaServed": "Mumbai, India",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Financial Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "SIP Investment Advisory",
              "description": "Systematic Investment Plan guidance and portfolio management"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Retirement Planning",
              "description": "Comprehensive retirement planning and wealth preservation strategies"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Tax Planning Services",
              "description": "Expert tax planning and optimization consulting"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Mutual Fund Consulting",
              "description": "Professional mutual fund selection and portfolio management"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "NRI Investment Services",
              "description": "Specialized investment advisory for Non-Resident Indians"
            }
          }
        ]
      }
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (script) {
      script.textContent = JSON.stringify(structuredData);
    } else {
      const newScript = document.createElement('script');
      newScript.type = "application/ld+json";
      newScript.textContent = JSON.stringify(structuredData);
      document.head.appendChild(newScript);
    }

    // GSAP Animation
    gsap.set(".services_card", {
      y: 200,
    });

    gsap.to(".services_card", {
      y: 0,
      duration: 1,
      stagger: 0.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".services_card",
        start: "top 80%",
        end: "bottom 20%",
      },
    });
  }, []);

  return (
    <>
      <header
        className="relative bg-cover bg-center h-screen text-white"
        style={{
          backgroundImage: `url(${Servicebg})`,
        }}
      >
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-3xl lg:text-7xl md:text-6xl font-bold text-[#78A742]">
            Strategic Financial Guidance <br /> for Long-Term Growth.
          </h1>
          <p className="mt-5 font-semibold text-black text-lg lg:text-2xl md:text-2xl max-w-xl">
            Trusted expertise. Proven outcomes
          </p>
        </div>
        <a
          href="https://wa.me/919892147989"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed z-[9999] bottom-6 right-4 sm:bottom-8 sm:right-8 bg-green-600 hover:bg-green-700 text-black font-bold text-lg px-5 py-2 rounded-full flex items-center space-x-2 shadow-md"
          aria-label="Chat with investment advisor on WhatsApp"
        >
          <span>Chat Now</span>
          <img src={whatsappicon} className="w-8" alt="WhatsApp chat" />
        </a>
      </header>

      <section className="mt-26 relative z-10 flex flex-col items-center justify-center h-full text-center px-4 border-b pb-6">
        <h2 className="text-3xl lg:text-5xl md:text-6xl font-bold text-[#78A742]">
          What do we offer?
        </h2>
        <p className="mt-3 lg:mt-10 text-black text-lg lg:text-2xl md:text-3xl max-w-4xl">
          At OakTree, we provide comprehensive financial solutions designed to
          help you build, manage, and protect your wealth.
        </p>
      </section>

      <section>
        <div className="flex flex-col gap-6 gap-y-7 lg:gap-y-10 p-6 px-3 lg:px-36">
          {services.map((category, index) => (
            <Link key={index} to="/contact" className="services_card" id={category.id}>
              <article
                className={`flex flex-col md:flex-row gap-20 justify-center items-center border-b pb-10 ${
                  index % 2 !== 0 ? "md:flex-row-reverse" : ""
                }`}
              >
                <div className="flex flex-col gap-3 ">
                  <div className="relative w-[21rem] h-[21rem] rounded-4xl overflow-hidden shadow-lg">
                    <img
                      src={category.img}
                      alt={`${category.name} financial planning services Mumbai`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button className="w-[350px] mt-3 bg-[#43AD7C] text-white px-4 py-3 rounded-4xl flex justify-center items-center gap-2 shadow-md relative">
                    {category.name}
                  </button>
                </div>

                <div className="max-w-[650px]">
                  <h3 className="text-3xl md:text-4xl font-semibold">
                    {category.infoTitle}
                  </h3>
                  <ul className="pl-4 md:p-0 list-disc mt-6">
                    {category?.infoList?.map((item, index) => (
                      <li key={index} className="text-lg">
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p className="text-lg mt-6 font-medium">
                    {category.footerTitle}
                  </p>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </section>

      <section className="flex flex-col items-center justify-center text-center space-y-4 py-8 px-4 bg-white">
        <p className="text-lg lg:text-4xl text-black font-normal leading-snug">
          We help you achieve your Financial Goals at
          <br />
          <span className="italic font-bold">every stage</span> of your life
        </p>
        <Link
          to="/contact"
          className="bg-[#A3D55D] hover:bg-[#A3D55D] text-black text-2xl font-medium px-5 py-[6px] mt-4 rounded-full transition"
          aria-label="Contact financial advisor for consultation"
        >
          Get in touch
        </Link>
      </section>

      <section className="bg-gradient-to-r from-[#0097b2] to-[#7ED957] py-8 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between">
          <div className="text-center mb-10 md:mb-0">
            <h2 className="text-3xl lg:text-7xl font-bold text-white mb-4">
              Ready to get started?
            </h2>
            <p className="text-white font-normal text-2xl lg:text-3xl mb-6">
              Take the first step towards a secure{" "}
              <br className="hidden md:block" />
              financial future with OakTree.
            </p>
          </div>

          <div className="relative w-[250px] h-[150px] lg:w-[500px] lg:h-[350px] bg-white overflow-hidden flex items-center justify-center rounded-[100%]">
            <img
              src={getstartedimg}
              alt="Investment growth chart - financial planning Mumbai"
              className="w-[150px] lg:w-[385px] object-contain"
            />
          </div>
        </div>
      </section>
    </>
  );
}